import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { IImportProcess } from "../interfaces/import-process.interface";
import { inject } from "@angular/core";
import { StockStatisticsApiService } from "../services/stock-statistics-api.service";

export const importProcessResolver: ResolveFn<IImportProcess> = (route: ActivatedRouteSnapshot) => {
  const importProcessApiService = inject(StockStatisticsApiService);

  return importProcessApiService.importProcess(route.paramMap.get("id")!);
};
